import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { BaseComponent } from '../../../shared/utils/base.component';
import { RADIO_BOOLEAN_YES_NO_OPTIONS } from '../../../shared/constants/static-data.constants';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { SectionsService } from '../../../services/sections.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzCardModule } from 'ng-zorro-antd/card';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { EnrollmentDataService } from '../../../services/enrollment-data.service';
import { performValidation } from '../../../shared/utils/validation.util';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'ppl-additional-demographics',
  standalone: true,
  imports: [
    NzFormModule,
    NzInputModule,
    NzRadioModule,
    CommonModule,
    ButtonModule,
    NzToolTipModule,
    NzCardModule,
    ButtonComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './additional-demographics.component.html',
  styleUrl: './additional-demographics.component.css',
})
export class AdditionalDemographicsComponent
  extends BaseComponent
  implements OnInit {
  radioBooleanOptions = RADIO_BOOLEAN_YES_NO_OPTIONS;
  additionalDemoForm!: FormGroup;
  program: any;
  @Input() id: any;
  @Output() onUpdate = new EventEmitter<any>();
  validationResponse: any;
  disableSaveButton = true;

  constructor(
    private fb: FormBuilder,
    private sectionsService: SectionsService,
    private enrollmentService: EnrollmentDataService,
    private userService: UserService
  ) {
    super();
  }

  ngOnInit(): void {
    this.additionalDemoForm = this.fb.group({
      isSnapReceived: [null],
      isTanfReceived: [null],
      isSsiReceived: [null],
      isUnemployed: [null],
      isVeteran: [null],
      isDisabilityComp: [null],
      isWotcCertified: [{ value: null, disabled: true }],
    });
    this.program = this.userService.getSelectedProgram();
    const steps = this.sectionsService.getAdditionalDemoData(
      this.program.program_code
    );
    this.secData = steps.additional_demo;
    this.additionalDemoForm.valueChanges.subscribe(() => {
      if (
        (this.additionalDemoForm.value.isSnapReceived !== null &&
          this.additionalDemoForm.value.isSnapReceived !== undefined) ||
        (this.additionalDemoForm.value.isTanfReceived !== null &&
          this.additionalDemoForm.value.isTanfReceived !== undefined) ||
        (this.additionalDemoForm.value.isSsiReceived !== null &&
          this.additionalDemoForm.value.isSsiReceived !== undefined) ||
        (this.additionalDemoForm.value.isUnemployed !== null &&
          this.additionalDemoForm.value.isUnemployed !== undefined) ||
        (this.additionalDemoForm.value.isVeteran !== null &&
          this.additionalDemoForm.value.isVeteran !== undefined)
      ) {
        this.additionalDemoForm.get('isWotcCertified')?.enable();
        this.disableSaveButton = false;
      } else {
        this.additionalDemoForm.get('isWotcCertified')?.disable();
        this.disableSaveButton = true;
      }
    });
  }

  updateDemographics() {
    const formData = this.additionalDemoForm.value;
    this.validationResponse = this.validateForm(formData);

    if (this.validationResponse.valid) {
      const payload = {
        ...this.additionalDemoForm.value,
        programCode: this.program.program_code,
        id: this.id,
      };
      this.enrollmentService
        .updateWotcQuestions(payload)
        .subscribe((data: any) => {
          this.onUpdate.emit();
        });
    }
  }

  validateForm(formData: any) {
    const {
      isSnapReceived,
      isTanfReceived,
      isSsiReceived,
      isUnemployed,
      isVeteran,
      isWotcCertified
    } = formData;
  
    const anyEligibilitySelected = [
      isSnapReceived,
      isTanfReceived,
      isSsiReceived,
      isUnemployed,
      isVeteran
    ].some(value => value === true || value === false);
  
    if (!isWotcCertified || !anyEligibilitySelected || (anyEligibilitySelected && !isWotcCertified)) {
      return {
        valid: false,
        message: "Selecting the checkbox is mandatory if at least one question has been answered"
      };
    }
  
    return { valid: true };
  }
}
